


























































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import UserResearchCenter from "@/models/security/userResearchCenter.Model";
import Tag from "../../models/history/tag.model";
import Record from "../../models/history/record.model";
import HistoryService from "@/services/History.service";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import BTableColumn from "@/models/base/BTableColumn.model";
import BaseSelectTag from "@/components/base/baseSelectTag/baseSelectTag.vue";
import fileService from "@/services/file.service";
import RecordTag from "../../models/history/recordTag.model";
@Component({
  components: {
    BaseSelectTag
  }
})
export default class RecordEdit extends GenericAdd<Record> {
  loading: boolean = false;
  tagLoading: boolean = false;
  tagModel: Tag = new Tag();
  model: Record = new Record();
  historyService: HistoryService = new HistoryService();
  tableConfig: BTableConfig<Tag> = new BTableConfig<Tag>();
  file: any = null;
  tags: any = [];
  savedTags: any = [];

  constructor() {
    super();
    this.controller = "Record";
    this.model = new Record();
  }

  async mounted() {
    let id = Number(this.$route.params.id);
    let data = await this.historyService.getRecordById(id);
    this.model = this.map<Record>(data);
    this.savedTags = data.recordTags;
    this.file = this.model.document;
  }

  cancel_custom() {
    let parentId = this.$route.params.hasOwnProperty("parentId")
      ? Number(this.$route.params.parentId)
      : null;

    if (this.modelDoNotChange) {
      parentId && !isNaN(parentId)
        ? this.$router.push(`/historico/padre/${parentId}`)
        : this.$router.push(`/historico/`);
      return;
    }

    this.$buefy.dialog.confirm({
      title: "Advertencia",
      type: "is-warning",
      size: "is-medium",
      hasIcon: true,
      confirmText: "Salir",
      cancelText: "No",
      message: "¿Seguro que desea salir de la sección?",
      onConfirm: () => {
        parentId && !isNaN(parentId)
          ? this.$router.push(`/historico/padre/${parentId}`)
          : this.$router.push(`/historico/`);
      }
    });
  }

  setTags(data: []) {
    this.tags = data;
  }

  cleanWithFile() {
    this.file = null;
    this.clean();
  }

  async saveTag() {
    if (this.tagModel.name) {
      this.tagLoading = true;
      this.historyService.saveTag(this.tagModel).then(response => {
        this.tableConfig.reload();
        this.operationSuccess();
        this.tagLoading = false;
      });
    } else {
      this.operationNoAllowed("Debe agregar un tag");
    }
  }

  async removeTag(id: number, tag: Tag) {
    this.loading = true;
    await this.historyService.deleteTag(id);
    this.tableConfig.reload();
    this.operationSuccess();
    this.loading = false;
  }

  protected async validate() {
    try {
      var result = await this.$validator.validateAll();
      if (result) {
        this.add();
        return;
      }
      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  }

  protected async add() {
    try {
      if (this.model.name) {
        this.loading = true;
        this.saving = true;
        if (this.file) {
          let doc = this.file.id
            ? this.file
            : await fileService.upload(this.file as File);
          doc.refEntityKey = "Id";
          doc.refEntityName = "Record";
          if (this.model.document) {
            doc.refEntityValue = String(this.model.id);
            doc.id = this.model.document.id;
          }
          this.model.document = doc;
        }

        if (this.tags) {
          
          let tagsComunes = this.model.recordTags.filter(x =>
            this.tags.some(y => y.id == x.tag.id)
          );
          let tagsNuevos = this.tags.filter(x => {
            if (!tagsComunes.some(y => y.tagId == x.id)) {
              return x;
            }
          });
          let tagsEliminados = this.model.recordTags.filter(x => {
            if (!tagsComunes.some(y => y.tagId == x.tagId)) {
              return x;
            }
          });
          tagsEliminados.forEach(tag => {
            tag.deleted = true;
          });
          tagsNuevos.forEach(tag => {
            let recordTag = new RecordTag();
            recordTag.tagId = tag.id;
            this.model.recordTags.push(recordTag);
          });
        }

        let id = this.$route.params.hasOwnProperty("parentId")
          ? Number(this.$route.params.parentId)
          : null;
        if (id && !isNaN(id)) {
          this.model.parentId = id;
        }

        let result = await this.historyService.updateRecord(this.model);
        this.saving = false;
        this.loading = false;
        this.$emit("add", result);
        this.clean();
        this.operationSuccess();
        
        if (this.exitOnSave) {
          let id = this.$route.params.hasOwnProperty("parentId")
            ? Number(this.$route.params.parentId)
            : null;
          if (id && !isNaN(id)) {
            this.$router.push(`/historico/padre/${id}`);
          } else {
            this.$router.push(`/historico`);
          }
        }
      } else {
        this.operationNoAllowed("Debe escribir un nombre");
        return;
      }
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.saving = false;
    }
  }

  get user() {
    return this.$store.state.user;
  }
}
